import { useEffect, useRef, useState } from 'react';
import clsx from 'clsx';

import { useVoices } from '../../providers/VoicesProvider';
import { newStyles } from '../elements/StyleJigsaw';

import { LanguageSelector } from './languageSelector';
import { StyleSelector } from './StyleSelector';

export function EditorHeader() {
  const { voices: allVoicesData } = useVoices();
  
  const styles = newStyles;
  const emtionTabRef = useRef<HTMLDivElement>(null);
  const [showScrolledDirectionLanguage, setShowScrolledDirectionLanguage] =
    useState({
      left: false,
      right: true,
    });
  useEffect(() => {
    const activeLanguage = emtionTabRef.current?.querySelector(
      '[data-active="true"]',
    );
    if (activeLanguage && activeLanguage instanceof HTMLElement) {
      const offsetLeft = activeLanguage.offsetLeft;
      emtionTabRef.current?.scrollTo({
        left: offsetLeft - 100,
        behavior: 'smooth',
      });
    }
  }, []);

  useEffect(() => {
    const checkScrollLanguage = () => {
      if (emtionTabRef.current) {
        const showLeftButton = emtionTabRef.current.scrollLeft > 10;
        const showRightButton =
          emtionTabRef.current.scrollLeft +
            emtionTabRef.current.clientWidth +
            10 <
          emtionTabRef.current.scrollWidth;

        setShowScrolledDirectionLanguage({
          left: showLeftButton,
          right: showRightButton,
        });
      }
    };

    const elementLanguage = emtionTabRef.current;
    elementLanguage?.addEventListener('scroll', checkScrollLanguage);

    checkScrollLanguage();

    // Cleanup
    return () => {
      elementLanguage?.removeEventListener('scroll', checkScrollLanguage);
    };
  }, []);

  return (
    <div className="flex items-start gap-2 @md:mx-0 @lg:mx-0 @lg:items-center">
      <LanguageSelector allLanguages={allVoicesData} />
      <div className="h-[22px] w-px self-center bg-[#F5F5FA]" />
      <div className="flex w-full min-w-0 flex-1 items-center @lg:gap-1">
        <div className="relative min-w-0 flex-1">
          <span
            className={clsx(
              'absolute inset-y-0 left-0 z-10 w-8 bg-gradient-to-r from-white to-transparent @lg:w-10',
              { hidden: !showScrolledDirectionLanguage.left },
            )}
          />
          <div
            className="overflow-x-scroll py-1 pl-1 no-scrollbar"
            ref={emtionTabRef}>
            <StyleSelector languages={styles} isLoading={false} />
          </div>
        </div>
      </div>
    </div>
  );
}
